/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect, useContext } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import FormField from "layouts/applications/wizard/components/FormField";
import { useNavigate, useLocation } from "react-router-dom";
import { Autocomplete, Badge, IconButton, Tooltip } from "@mui/material";
import { MODULE_MASTER } from "utils/constant"
import { toast } from 'react-toastify';
import 'material-react-toastify/dist/ReactToastify.css';

import CrudService from "services/cruds-service";
import ModalModuleAddress from "../add-module";
import { AuthContext } from "context";
import DataTable from "examples/Tables/DataTable";
import DeleteIcon from "@mui/icons-material/Delete";
import { AbilityContext } from "Can";
import { useAbility } from "@casl/react";

const NewEntity = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { text, value } = location.state || {};
  const ability = useAbility(AbilityContext)

  if (!ability.can('view', 'entities')) {
    navigate('/entity-list')
  }

  const [name, setName] = useState({
    text: "",
    error: false,
    textError: "",
  });

  const [firstName, setFirstName] = useState({
    text: "",
    error: false,
    textError: "",
  });

  const [lastName, setLastName] = useState({
    text: "",
    error: false,
    textError: "",
  });

  const [notification, setNotification] = useState({
    value: false,
    text: "",
  });

  const [company, setCompany] = useState("");
  const [companies, setCompanies] = useState([]);
  const [addressTypes, setAddressTypes] = useState([]);
  const [entityType, setEntityType] = useState([]);
  const [entityTypes, setEntityTypes] = useState([]);
  const [statusAddress, setStatusAddress] = useState([]);
  const [statusType, setStatusType] = useState([]);
  const [statusEntity, setStatusEntity] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [selectedId, setSelectedId] = useState(0);
  const [items, setItems] = useState([]);
  const [attributeValue, setAttributeValue] = useState([]);
  const [module, setModule] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [contactForm, setContactForm] = useState({})

  ///////////////// contact addresss ////////////////
  const authContext = useContext(AuthContext)

  // const [descError, setDescError] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const response = await CrudService.getEntityTypes();
        setEntityTypes(response.data);
      } catch (err) {
        console.error(err);
        return null;
      }
    })();
    (async () => {
      try {
        const response = await CrudService.getCompanies();
        setCompanies(response.data);
      } catch (err) {
        console.error(err);
        return null;
      }
    })();
    (async () => {
      try {
        const response = await CrudService.getAddressTypes();
        setAddressTypes(response.data);
      } catch (err) {
        console.error(err);
        return null;
      }
    })();

    (async () => {
      try {
        const response = await CrudService.getStatusTypes(MODULE_MASTER.ADDRESS);
        setStatusAddress(response.data);
      } catch (err) {
        console.error(err);
        return null;
      }
    })();

    (async () => {
      const response = await CrudService.getContacts();
      setContacts(response.data);
    })();

    (async () => {
      try {
        const response = await CrudService.getStatusTypes(MODULE_MASTER.ENTITIES);
        setStatusEntity(response.data);
        setStatusType(response.default_id);
      } catch (err) {
        console.error(err);
        return null;
      }
    })();

    (async () => {
      const response = await CrudService.getItems();
      const formattedItems = response.data.map(element => {
        // Rename 'item_id' field to 'id' and include the existing 'id' field
        const { item_id, id, ...attributes } = element.attributes;
        return { id: item_id, AttributeValue: [], ...attributes };
      });
      setItems(formattedItems);
    })();
    if (authContext.entityData) {
      fillTheData(authContext.entityData)
    }
  }, []);

  function fillTheData(value) {
    setAddresses(value.addresses)
    setName(value.name)
    setFirstName(value.first_name)
    setLastName(value.last_name)
    setCompany(value.company)
    setEntityType(value.entityType)
    setStatusType(value.statusType)
    setSelectedId(value.selectedId)
  }

  useEffect(() => {
    if (contactForm && contacts.length > 0) {
      if (contactForm?.selectedContactIDs) {
        let filterContact = contacts.filter((e) => contactForm?.selectedContactIDs.includes(e.id))
        setSelectedContacts(filterContact)
      }
      if (contactForm?.contact && contactForm?.contact?.contact_first_name) {
        const payload = {
          isNew: true,
          ...contactForm?.contact
        }
        setSelectedContacts((prev) => [...prev, {...payload}])
      }
    }
  }, [contactForm, contacts])

  useEffect(() => {
    if (value) {
      setContactForm(value)
    }

  }, [value])

  useEffect(() => {
    if (notification.value === true) {
      let timer = setTimeout(() => {
        setNotification({
          value: false,
          text: "",
        });
      }, 5000);
    }
  }, [notification]);


  const showToast = (result) => {
    setNotification({
      value: true,
      text: result,
      bgColor: "error",
    });
  };

  const removeList = (index) => {
    const updatedContactList = [...selectedContacts]
    updatedContactList.splice(index, 1)
    setSelectedContacts(updatedContactList)
  }

  const submitHandler = async (e) => {
    e.preventDefault();

    // let descNoTags = description.replace(/(<([^>]+)>)/gi, "");
    // if (descNoTags < 1) {
    //   setDescError(true);
    //   return;
    // }
    let hasInvalidAddress = false;

    addresses.forEach(address => {
      if (address.status_type_id === '') {
        toast.warning('Please set Status of Address!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        hasInvalidAddress = true; // Set the flag to true if an invalid address is found
        return;
      }
      if (address.address_type_id === '') {
        toast.warning('Please set Type of Address!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        hasInvalidAddress = true
        return;
      }

    })

    if (hasInvalidAddress) {
      return;
    }

    let selectedContactIDs = selectedContacts.map(contact => contact?.attributes?.contact_id);

    const entity = {
      data: {
        type: "entities",
        attributes: {
          name: name.text,
          first_name: firstName.text,
          last_name: lastName.text,
          company: company?.attributes,
          entityType: entityType?.attributes,
          statusType: statusType?.attributes,
          addresses,
          contact: contactForm?.contact ?? {},
          selectedContactIDs: selectedContactIDs
        },
        selectedId: selectedId,
      },
    };
    try {
      authContext.startLoading()
      const result = await CrudService.createEntity(entity);
      authContext.setEntityInfo(null)
      navigate("/entity-list", {
        state: { value: true, text: "The entity was successfully created" },
      });
    } catch (err) {
      if (err.hasOwnProperty("error")) {
        setName({ ...name, error: true, textError: err.error });
      }
      console.error(err);

      showToast(err.error);
    } finally {
      authContext.stopLoading()
    }
  };

  const isOptionEqualToValueEntityStatus = (option, value) => {
    return option.attributes?.StatusType.status_name === value.attributes?.StatusType.status_name;
  };

  const isOptionEqualToValueEntityCompany = (option, value) => {
    return option?.attributes?.company_id === value?.attributes?.company_id;
  };

  const isOptionEqualToValueEntityType = (option, value) => {
    return option?.attributes?.entity_type_id === value?.attributes?.entity_type_id;
  };

  const getRows = (info) => {
    let updatedInfo = info.map((row) => {
      if (row?.isNew) {
        return {
          type: "contacts",
          id: 0,
          first_name: row.contact_first_name,
          last_name: row.contact_last_name,
          type: row.contactType?.type_name,
          phone: row.phoneAddresses.length > 0 ? row.phoneAddresses[0].contact_address : '', // Render phone.contact_address if phone exists, otherwise an empty string
          email: row.emailAddresses.length > 0 ? row.emailAddresses[0].contact_address : '', // Render email.contact_address if email exists, otherwise an empty string
          fax: row.faxAddresses.length > 0 ? row.faxAddresses[0].contact_address : '',
          status_badge: (
            <Badge
              color={row?.contactStatusType?.BadgeDetail?.color || 'primary'}
              variant={row?.contactStatusType?.BadgeDetail?.variant}
              badgeContent={row?.contactStatusType?.StatusType?.status_name}
              style={{ marginLeft: '30px' }}
            >
            </Badge>
          ),
        }
      }
      let phone = row?.attributes?.ContactAddresses.find(contact => contact.address_type_id === 1 && contact.is_default === true);
      let email = row?.attributes?.ContactAddresses.find(contact => contact.address_type_id === 2 && contact.is_default === true);
      let fax = row?.attributes?.ContactAddresses.find(contact => contact.address_type_id === 3 && contact.is_default === true);
      return {
        // StatusType: row.attributes?.StatusOption,
        status_badge: (
          <Badge
            color={row.attributes?.StatusOption?.BadgeDetail?.color || 'primary'}
            variant={row.attributes?.StatusOption?.BadgeDetail?.variant}
            badgeContent={row.attributes?.StatusOption?.StatusType?.status_name}
            style={{ marginLeft: '30px' }}
          >
          </Badge>
        ),
        status: row.attributes?.StatusOption,
        type: "contacts",
        id: row.attributes?.contact_id,
        first_name: row.attributes?.first_name,
        last_name: row.attributes?.last_name,
        type: row.attributes?.ContactType?.type_name,
        phone: phone ? phone.contact_address : '', // Render phone.contact_address if phone exists, otherwise an empty string
        email: email ? email.contact_address : '', // Render email.contact_address if email exists, otherwise an empty string
        fax: fax ? fax.contact_address : '',
      };
    });
    return updatedInfo;
  };

  const dataTableAllData = {
    columns: [
      { Header: "Status", accessor: "status_badge", width: "15%" },
      { Header: "First Name", accessor: "first_name", width: "15%" },
      { Header: "Last Name", accessor: "last_name", width: "15%" },
      { Header: "Type", accessor: "type", width: "20%" },
      { Header: "Phone", accessor: "phone", width: "15%" },
      { Header: "Email", accessor: "email", width: "15%" },
      { Header: "Fax", accessor: "fax", width: "15%" },
      {
        Header: "actions",
        disableSortBy: true,
        accessor: "",
        Cell: (info) => {
          return (
            <MDBox display="flex" alignItems="center">
              {(
                <Tooltip title="Delete Parameter">
                  <IconButton onClick={() => removeList(info.cell.row.index)}>
                    <MDTypography><DeleteIcon /></MDTypography>
                  </IconButton>
                </Tooltip>
              )}
            </MDBox>
          );
        },
      }
    ],
    rows: getRows(selectedContacts),
  };

  const openContactPage = () => {

    const payload = {
      name: name,
      first_name: firstName,
      last_name: lastName,
      company: company,
      entityType: entityType,
      statusType: statusType,
      addresses,
      selectedId: selectedId,
    }
    authContext.setEntityInfo(payload)
    navigate(`/entity-management/new-entity/contact`)
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* <ToastContainer/> */}

      {notification.value && (
        <MDAlert
          color={notification.bgColor}
          my="20px"
          sx={{
            position: "sticky",
            top: { md: "100px", xs: "50px" },
            zIndex: "10000",
          }}
        >
          <MDTypography variant="body2" color="white">
            {notification.text || ""}
          </MDTypography>
        </MDAlert>
      )}

      <MDBox mt={5} mb={9}>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={8}>
            <MDBox mt={6} mb={8} textAlign="center">
              <MDBox mb={1}>
                <MDTypography variant="h3" fontWeight="bold">
                  Add New Entity
                </MDTypography>
              </MDBox>
              <MDTypography variant="h5" fontWeight="regular" color="secondary">
                This information will describe more about the entity.
              </MDTypography>
            </MDBox>
            <Card>
              <MDBox component="form" method="POST" onSubmit={submitHandler}>
                <MDBox display="flex" flexDirection="column" px={3} my={2}>
                  <MDBox p={1}>
                    <Autocomplete
                      defaultValue=""
                      options={entityTypes}
                      getOptionLabel={(option) => (option.attributes ? option.attributes.type_name : "")}
                      value={entityTypes.find(option => isOptionEqualToValueEntityType(option, entityType)) ?? null} // Find matching option or set to null if not found
                      onChange={(event, newEntityType) => {
                        setEntityType(newEntityType);
                      }}
                      isOptionEqualToValue={isOptionEqualToValueEntityType}
                      renderInput={(params) => (
                        <FormField {...params} label="Entity Type" InputLabelProps={{ shrink: true }} required />
                      )}
                    />

                    {entityType.id === 1 && (
                      <>
                        <FormField
                          required
                          type="text"
                          label="First Name"
                          name="firstName"
                          value={firstName.text || ""}
                          onChange={(e) => setFirstName({ ...firstName, text: e.target.value })}
                          error={firstName.error}
                        />
                        {firstName.error && (
                          <MDTypography variant="caption" color="error" fontWeight="light">
                            {firstName.textError}
                          </MDTypography>
                        )}

                        <FormField
                          required
                          type="text"
                          label="Last Name"
                          name="lastName"
                          value={lastName.text || ""}
                          onChange={(e) => setLastName({ ...lastName, text: e.target.value })}
                          error={lastName.error}
                        />
                        {lastName.error && (
                          <MDTypography variant="caption" color="error" fontWeight="light">
                            {lastName.textError}
                          </MDTypography>
                        )}
                      </>
                    )}


                    {entityType.id === 2 && (
                      <>
                        <FormField
                          required
                          type="text"
                          label="Name"
                          name="name"
                          value={name.text || ""}
                          onChange={(e) => setName({ ...name, text: e.target.value })}
                          error={name.error}
                        />
                        {name.error && (
                          <MDTypography variant="caption" color="error" fontWeight="light">
                            {name.textError}
                          </MDTypography>
                        )}
                      </>
                    )}

                    <Autocomplete
                      defaultValue=""
                      options={companies}
                      getOptionLabel={(option) => (option.attributes ? option.attributes.name : "")}
                      value={companies.find(option => isOptionEqualToValueEntityCompany(option, company)) ?? null} // Find matching option or set to null if not found
                      onChange={(event, newCompany) => {
                        setCompany(newCompany);
                      }}
                      isOptionEqualToValue={isOptionEqualToValueEntityCompany}
                      renderInput={(params) => (
                        <FormField {...params} label="Company" InputLabelProps={{ shrink: true }} required />
                      )}
                    />

                    <Autocomplete
                      defaultValue=""
                      options={statusEntity}
                      getOptionLabel={(option) => (option.attributes ? option.attributes?.StatusType.status_name : "")}
                      value={statusType ?? null}
                      onChange={(event, newStatus) => {
                        setStatusType(newStatus);
                      }}
                      isOptionEqualToValue={isOptionEqualToValueEntityStatus} // Custom equality function
                      disableClearable
                      renderInput={(params) => (
                        <FormField {...params} label="Status" InputLabelProps={{ shrink: true }} required />
                      )}
                    />

                  </MDBox>
                  <ModalModuleAddress addressTypes={addressTypes} statusOptions={statusAddress} addresses={addresses} setAddresses={setAddresses} selectedId={selectedId} setSelectedId={setSelectedId} moduleData={items} moduleType="Item" attributeValue={attributeValue} setAttributeValue={setAttributeValue} module={module} setModule={setModule} />

                  <Card sx={{ marginTop: '1rem', padding: '1rem 0' }}>
                    <MDTypography variant="h5" fontWeight="bold" ml={3}>
                      Contacts
                      <MDButton variant="gradient" color="dark" size="small" style={{ marginLeft: '10px' }} onClick={() => openContactPage()}>
                        + Add Contact
                      </MDButton>
                    </MDTypography>
                    {/* { value?.contact ? 
                      <ModalContact
                        contactType={contactType} setContactType={setContactType}
                        contactStatusType={contactStatusType} setContactStatusType={setContactStatusType}
                        statusContact={statusContact} setStatusContact={setStatusContact}
                        phoneAddresses={phoneAddresses} setPhoneAddresses={setPhoneAddresses}
                        emailAddresses={emailAddresses} setEmailAddresses={setEmailAddresses}
                        faxAddresses={faxAddresses} setFaxAddresses={setFaxAddresses}
                        selectedPhoneId={selectedPhoneId} setSelectedPhoneId={setSelectedPhoneId}
                        selectedEmailId={selectedEmailId} setSelectedEmailId={setSelectedEmailId}
                        selectedFaxId={selectedFaxId} setSelectedFaxId={setSelectedFaxId}
                        contact_first_name={contact_first_name} setContactFirstName={setContactFirstName}
                        contact_last_name={contact_last_name} setContactLastName={setContactLastName}
                      /> : ''
                    } */}
                    {
                      selectedContacts.length > 0 ?
                        <DataTable table={dataTableAllData} /> : ''
                    }

                  </Card>

                  <MDBox ml="auto" mt={4} mb={2} display="flex" justifyContent="flex-end">
                    <MDBox mx={2}>
                      <MDButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        px={2}
                        mx={2}
                        onClick={() => {
                          authContext.setEntityInfo(null)
                          navigate("/entity-list", {
                            state: { value: false, text: "" },
                          })
                        }
                        }
                      >
                        Back
                      </MDButton>
                    </MDBox>
                    <MDButton variant="gradient" color="dark" size="small" type="submit">
                      Save
                    </MDButton>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default NewEntity;
